import React from "react"

import SEO from "../components/common/SEO"

import ContactInfo from "../components/contact/ContactInfo"
import ContactForm from "../components/contact/ContactForm"
import MapSection from "../components/contact/MapSection"
import WhatsAppButton from "../components/contact/WhatsAppButton"

export default function Contact() {
  return (
    <>
      {/* SEO */}
      <SEO
        title="Contact | Centre Spa Land Saphir Palace Hammamet Tunisia"
        description="Contactez notre centre de spa en Tunisie pour réserver des massages, des hammams, des soins du visage et des traitements de bien-être."
        keywords="Contactez un spa, réservez un spa en Tunisie, contactez un hammam, prenez rendez-vous pour un massage"
        url="https://www.yourdomain.com/contact"
      />

      <main className="overflow-x-hidden">
        {/* Hero */}
        <section className="py-20 lg:py-28 bg-[#f9f6f1] text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-[#111111]">
            Contactez-Nous
          </h1>

          <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
            Réservez votre soin au spa ou posez-nous vos questions — nous sommes là pour vous aider à vous détendre.
          </p>
        </section>

        <ContactInfo />
        <ContactForm />
        <MapSection />
        <WhatsAppButton />
      </main>
    </>
  )
}